{
    "RandomiseTitle": "Passwort randomisieren",
    "PasswordStrength": "Passwortstärke:",
    "PasswordStrength_0": "Zu kurz",
    "PasswordStrength_1": "Sehr schwach",
    "PasswordStrength_2": "Schwach",
    "PasswordStrength_3": "Mäßig",
    "PasswordStrength_4": "Stark",
    "PasswordStrength_5": "Sehr stark",
    "NAME": "PasswordTextInput",
    "PasswordRequirements_Title": "Passwort-Anforderungen:"
}